import { Inject, Injectable } from '@angular/core';

import { map, mergeMap, Observable } from 'rxjs';

import {
  BackendUploadService,
  InputControlData,
  InputControlTypes,
  InputUtils,
  ItemView,
  ItemViewProviderDirective,
  NotificationService,
  NtapGlobalConstants,
  Util
} from '@ntap/core';

import { AppConfig, appConfigService } from '@app/config';
import { ARHIV_POSJEDNIK } from '@app/shared/models/types';

export type ItemWithUrl = {
  imageUrl: string;
  imageCommentFormControlName: string;
  imageComment: string;
};

@Injectable()
export class ImagePanelItemProviderService {
  public itemWithImageUrl$: Observable<ItemWithUrl>;
  public imageCommentInputParam$: Observable<InputControlData>;
  public imageCommentAttrName: string;

  constructor(
    protected itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected notificationService: NotificationService,
    protected backendUploadService: BackendUploadService,
    @Inject(appConfigService) private config: AppConfig
  ) {
    this.itemWithImageUrl$ = this.itemViewProvider.item$.pipe(
      map((item: any) => this.toItemWithUrl(item))
    );
    this.imageCommentInputParam$ = this.itemWithImageUrl$.pipe(
      mergeMap((item: ItemWithUrl) => this.toImageCommentInputControl(item))
    );
  }

  protected toItemWithUrl(item: any) {
    // kontrola s ovim imenom sluzi za prijenos podataka datoteke
    // bitno je da je inicijaliziramo nakon sto dodu podaci itema
    let itemType =
      item[NtapGlobalConstants.ATTR_$mainType] ||
      item[NtapGlobalConstants.ATTR_$itemType];
    itemType = itemType === ARHIV_POSJEDNIK ? 'en~agent' : itemType; // FIXME hack - buduci da se slika preuzima iz agenta, ne iz arhiv_posjednik
    const idAttr = Util.getFullAttrName(itemType, NtapGlobalConstants.ATTR_id);
    const id =
      item[idAttr] || item['en~arhiv_posjednik~agent_normativna_baza_id'];
    const url =
      this.config.ntapEnvironment?.pathApiNtap +
        `/content/readContent?objectType=${itemType}&objectId=${id}&renditionName=${this.getRenditionName()}` ||
      '';
    const imageUrl = item['$hasContent'] ? url : null;
    this.imageCommentAttrName = Util.getFullAttrName(
      itemType,
      'napomena_uz_sliku'
    );
    const merged = Object.assign({}, item, {
      imageUrl: imageUrl,
      imageCommentFormControlName: this.imageCommentAttrName,
      imageComment: item[this.imageCommentAttrName]
    });

    return merged as ItemWithUrl;
  }

  protected getRenditionName(): string {
    return 'default';
  }

  protected toImageCommentInputControl(item: ItemWithUrl) {
    return this.itemViewProvider.view$.pipe(
      map((view: any) => {
        return view.attributes.filter(
          (attr: any) => this.imageCommentAttrName === attr.$fqan
        );
      }),
      map((viewAttrs: any[]) => {
        const mappedAttrs = viewAttrs.map((attr: any) => {
          const clonedAttr = Object.assign({}, attr);
          // prikazujemo kao textarea, iako je vec hardkodiran tip inputa u template
          // ovo treba da ga attrsToInputControls ne filtrira van
          clonedAttr.control_type = InputControlTypes.TEXTAREA;
          return clonedAttr;
        });
        return InputUtils.attrsToInputControls(
          mappedAttrs,
          (inputControl: InputControlData) =>
            this.itemViewProvider.getItemValue(
              item,
              inputControl.attributeMetadata.name
            )
        )[0];
      })
    );
  }
}
